export default __webpack_public_path__ + "static/media/blog-17.0b11eb8a.jpeg";